class CountdownTimer extends HTMLElement {
    /**
     * Target date for the countdown
     * 
     * @type {number}
     */
    targetDate;

    /**
     * Countdown elements
     * 
     * @type {Object}
     */
    countdownElements;

    constructor() {
        super();

        // Initialize countdownElements directly
        this.countdownElements = {
            daysTens: this.querySelector('#times_day_tens'),
            daysOnes: this.querySelector('#times_day_ones'),
            hoursTens: this.querySelector('#times_hour_tens'),
            hoursOnes: this.querySelector('#times_hour_ones'),
            minutesTens: this.querySelector('#times_minute_tens'),
            minutesOnes: this.querySelector('#times_minute_ones'),
            secondsTens: this.querySelector('#times_second_tens'),
            secondsOnes: this.querySelector('#times_second_ones')
        };

        // Initialize targetDate from data-date attribute
        this.targetDate = new Date(this.getAttribute("data-date")).getTime();
        this.updateCountdown();

        // Update every second
        setInterval(() => this.updateCountdown(), 1000);
    }

    updateCountdown() {
        const now = new Date().getTime();
        const timeRemaining = this.targetDate - now;

        if (timeRemaining <= 0) {
            // Countdown is over
            this.resetCountdown();
        } else {
            // Calculate remaining days, hours, minutes, and seconds
            const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

            // Update countdown elements
            this.updateElement(this.countdownElements.daysTens, days > 0 ? Math.floor(days / 10).toString() : '0');
            this.updateElement(this.countdownElements.daysOnes, (days % 10).toString());
            this.updateElement(this.countdownElements.hoursTens, Math.floor(hours / 10).toString());
            this.updateElement(this.countdownElements.hoursOnes, (hours % 10).toString());
            this.updateElement(this.countdownElements.minutesTens, Math.floor(minutes / 10).toString());
            this.updateElement(this.countdownElements.minutesOnes, (minutes % 10).toString());
            this.updateElement(this.countdownElements.secondsTens, Math.floor(seconds / 10).toString());
            this.updateElement(this.countdownElements.secondsOnes, (seconds % 10).toString());

            // Hide daysTensElement if days is 0
            this.countdownElements.daysTens.style.display = days > 0 ? 'inline-block' : 'none';
        }
    }

    updateElement(element, value) {
        if (element) {
            element.textContent = value;
        }
    }

    resetCountdown() {
        // Countdown is over
        for (const key in this.countdownElements) {
            this.updateElement(this.countdownElements[key], '0');
        }
    }
}

// Use custom element tag name without a dot
customElements.define('countdown-timer', CountdownTimer);
